<template>
  <div v-if="uiStore.isLoading || uiStore.isSubmitting" class="waiting">
    <div id="loaderImage"></div>
  </div>
</template>

<script setup>
import { useUiStore } from '../../stores/useUiStore'
const uiStore = useUiStore()
</script>
